import * as React from "react";

import { Icon } from "components/icons/Icon";
import { cn } from "lib/utils";

type IconButtonVariant = "default" | "secondary";

const baseClasses =
  "inline-flex items-center justify-center transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2";

const variantClasses: Record<IconButtonVariant, string> = {
  default: "",
  secondary: "rounded-full bg-gray-200 hover:bg-gray-300 p-3",
};

export interface IconButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ComponentProps<typeof Icon>["name"];
  iconSize?: number | string;
  label?: string;
  iconClassName?: string;
  variant?: IconButtonVariant;
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon,
      iconSize,
      label,
      className,
      iconClassName,
      title,
      variant = "default",
      "aria-label": ariaLabel,
      type = "button",
      ...props
    },
    ref,
  ) => {
    const resolvedAriaLabel = ariaLabel ?? label;

    return (
      <button
        ref={ref}
        type={type}
        className={cn(baseClasses, variantClasses[variant], className)}
        aria-label={resolvedAriaLabel}
        title={title ?? label}
        {...props}
      >
        <Icon name={icon} size={iconSize} className={iconClassName} />
      </button>
    );
  },
);

IconButton.displayName = "IconButton";
